import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ClientLoginPage from "@/pages/client/ClientLoginPage";

export const Route = createFileRoute("/client/login")({
  head: () => pageHead("Client Portal Sign In", "Sign in to the AKIVA Client Portal to review deliverables and KPIs.", "/client/login", true),
  component: ClientLoginPage,
});
